import { FONT_SIZE_CHANGED, VISION_IMPAIRED } from "../../constants/constants";

const initialState = {
  fontSize: "115",
  visionImpaired: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case VISION_IMPAIRED:
      return {
        ...state,
        visionImpaired: action.payload
      };
    case FONT_SIZE_CHANGED:
      return {
        ...state,
        fontSize: action.payload,
      };

    default: {
      return state;
    }
  }
};
